module.exports = __webpack_public_path__ + "img/canvas_image_4.1d8ae2a.jpg";